import PropTypes from 'prop-types';

import { useDatosGenerales } from '../hooks/useDatosGenerales';
import { useForm, useFormValidation } from '../../../hooks';

import { FileInputUploader, LightButton, PrimaryButton, TextInput } from '../../../components';

export const CedulasUpdate = ({ usuario, handleCancelarEditarCedulas }) => {

    const { updateCedulasMutation: { mutate: updateCedulas, isPending } } = useDatosGenerales();

    const { numeroMedicinaGeneral, numeroEspecialidad, numeroAlergia, numeroConsejoAlergia, onInputChange } = useForm({ numeroMedicinaGeneral: (typeof usuario.numeroMedicinaGeneral !== 'undefined') ? usuario.numeroMedicinaGeneral : '', numeroEspecialidad: (typeof usuario.numeroEspecialidad !== 'undefined') ? usuario.numeroEspecialidad : '', numeroAlergia: (typeof usuario.numeroAlergia !== 'undefined') ? usuario.numeroAlergia : '', numeroConsejoAlergia: (typeof usuario.numeroConsejoAlergia !== 'undefined') ? usuario.numeroConsejoAlergia : '' });

    const { isFormValid, formValidationStatus, formFields, startFormValidation, setFormFieldValidation } = useFormValidation([{field: 'numeroMedicinaGeneral', default: (typeof usuario.numeroMedicinaGeneral !== 'undefined' && usuario.numeroMedicinaGeneral !== '') ? true : false}, {field: 'numeroEspecialidad', default: true}, {field: 'numeroAlergia', default: (typeof usuario.numeroAlergia !== 'undefined' && usuario.numeroAlergia !== '') ? true : false}, {field: 'numeroConsejoAlergia', default: true}]);

    const uploadCedulaMedicinaGeneral = ( archivo ) => {
        
        updateCedulas({ data: { cedulaMedicinaGeneral: archivo }, callback: () => {} });
    
    }

    const uploadCedulaEspecialidad = ( archivo ) => {
        
        updateCedulas({ data: { cedulaEspecialidad: archivo }, callback: () => {} });
    
    }

    const uploadCedulaAlergia = ( archivo ) => {
        
        updateCedulas({ data: { cedulaAlergia: archivo }, callback: () => {} });
    
    }

    const uploadCedulaConsejoAlergia = ( archivo ) => {
        
        updateCedulas({ data: { cedulaConsejoAlergia: archivo }, callback: () => {} });
    
    }

    const onSubmit = async ( event ) => {
        event.preventDefault();
        
        if(formValidationStatus === 'checked' && isFormValid != null && isFormValid){
            updateCedulas({ data: { numeroMedicinaGeneral, numeroEspecialidad, numeroAlergia, numeroConsejoAlergia }, callback: handleCancelarEditarCedulas });
        }else{
            startFormValidation();
        }
    
    }

    return (
        <>
            <form onSubmit={ onSubmit }>
                <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-3 col-lg-2 col-xs-1">
                        <TextInput
                            formFieldStatus={ formFields['numeroMedicinaGeneral'].status }
                            label="Medicina general"
                            name="numeroMedicinaGeneral"
                            onChange={ onInputChange }
                            required={ true }
                            requiredIndicator={ true }
                            setFormFieldValidation={ setFormFieldValidation }
                            value={ String(numeroMedicinaGeneral) }
                        />
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-9 col-lg-10 col-xs-11">
                        <FileInputUploader
                            defaultValue={ usuario.cedulaMedicinaGeneralName }
                            disabled={ isPending }
                            label=""
                            name="cedulaMedicinaGeneral"
                            uploadFn={uploadCedulaMedicinaGeneral}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-3 col-lg-2 col-xs-1">
                        <TextInput
                            formFieldStatus={ formFields['numeroEspecialidad'].status }
                            label="Especialidad"
                            name="numeroEspecialidad"
                            onChange={ onInputChange }
                            required={ false }
                            requiredIndicator={ false }
                            setFormFieldValidation={ setFormFieldValidation }
                            value={ String(numeroEspecialidad) }
                        />
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-9 col-lg-10 col-xs-11">
                        <FileInputUploader
                            defaultValue={ usuario.cedulaEspecialidadName }
                            disabled={ isPending }
                            label=""
                            name="cedulaEspecialidad"
                            uploadFn={uploadCedulaEspecialidad}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-3 col-lg-2 col-xs-1">
                        <TextInput
                            formFieldStatus={ formFields['numeroAlergia'].status }
                            label="Alergía"
                            name="numeroAlergia"
                            onChange={ onInputChange }
                            required={ true }
                            requiredIndicator={ true }
                            setFormFieldValidation={ setFormFieldValidation }
                            value={ String(numeroAlergia) }
                        />
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-9 col-lg-10 col-xs-11">
                        <FileInputUploader
                            defaultValue={ usuario.cedulaAlergiaName }
                            disabled={ isPending }
                            label=""
                            name="cedulaAlergia"
                            uploadFn={uploadCedulaAlergia}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-3 col-lg-2 col-xs-1">
                        <TextInput
                            formFieldStatus={ formFields['numeroConsejoAlergia'].status }
                            label="Consejo de alergía"
                            name="numeroConsejoAlergia"
                            onChange={ onInputChange }
                            required={ false }
                            requiredIndicator={ false }
                            setFormFieldValidation={ setFormFieldValidation }
                            value={ String(numeroConsejoAlergia) }
                        />
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-9 col-lg-10 col-xs-11">
                        <FileInputUploader
                            defaultValue={ usuario.cedulaConsejoAlergiaName }
                            disabled={ isPending }
                            label=""
                            name="cedulaConsejoAlergia"
                            uploadFn={uploadCedulaConsejoAlergia}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <div className='d-flex justify-content-end'>
                            <LightButton
                                disabled={isPending || formValidationStatus === 'checking'}
                                icon="X"
                                marginRight={true}
                                onClick={handleCancelarEditarCedulas}
                                text="Cancelar"
                                type="button"
                            />
                            <PrimaryButton
                                disabled={isPending || formValidationStatus === 'checking'}
                                icon="Check"
                                text="Guardar"
                                type="submit"
                            />
                        </div>
                    </div>
                </div>
            </form>
        </>
    )
}

CedulasUpdate.propTypes = {
    usuario: PropTypes.object.isRequired,
    handleCancelarEditarCedulas: PropTypes.func.isRequired
}